import { Flex, TextV2, Box } from '@withjoy/joykit';
import { Close } from '@withjoy/joykit/icons';
import React from 'react';
import { useTranslation } from '@shared/core';
import { LocationDatesOccupants } from '@apps/stays/AccommodationsConsole/components/LocationDatesOccupantsSearchBar/LocationDatesOccupantsSearchBar';
import { getSearchFormInitialValue } from '@shared/utils/accommodations/AccommodationTiles';
import type { AccommodationsConsoleState, SearchFormConfig } from '@shared/types/Accommodations.types';
import type { StaysSearchTerms } from '@apps/stays/types';

export const MobileSearchComponent = ({
  onClose,
  state,
  handleFormSubmit,
  searchForm,
  accentColor,
}: {
  onClose: () => void;
  state: AccommodationsConsoleState;
  handleFormSubmit: (value: StaysSearchTerms) => void;
  searchForm: SearchFormConfig;
  accentColor?: string;
}) => {
  const { t } = useTranslation('accommodationsConsole');
  const mobileSearchTrans = t('mobileSearch');
  const initialValue = getSearchFormInitialValue(state);

  return (
    <>
      <Box height={'97%'}>
        <DrawerHeader
          title={mobileSearchTrans.title()}
          onClose={onClose}
        />
        <Box
          width={'100%'}
          paddingTop={4}
          height={'100%'}
        >
          <LocationDatesOccupants
            onSubmit={values => {
              onClose();
              handleFormSubmit(values);
            }}
            initialValue={initialValue}
            config={{
              ...searchForm,
              isOpenedFormView: true,
            }}
            accentColor={accentColor}
          />
        </Box>
      </Box>
    </>
  );
};

const DrawerHeader = ({ title, onClose }: { title: string; onClose: () => void }) => {
  return (
    <Flex
      justifyContent={'space-between'}
      paddingX={6}
      paddingTop={6}
    >
      <TextV2 typographyVariant="hed3">{title}</TextV2>
      <Close onClick={onClose} />
    </Flex>
  );
};
